import React from 'react';
import autoBind from 'react-autobind';
import SmartModal from '@common/components/modals/smartModal';
import { Modal } from 'react-bootstrap';
import { ModalManager } from '@common/helpers/modal.helper';

class ActionValidatorModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
    };
    autoBind(this);
  }

  async close(value) {
    this.props.onConfirm(value);
    ModalManager.close();
    await this.setState({ show: false });
  }

  onCancel() {
    this.close(null);
  }

  onClose() {
    this.close(false);
  }

  onConfirm() {
    this.close(true);
  }

  render() {
    const { title, message, html, hasCancel } = this.props;
    const { show } = this.state;

    return (
      <SmartModal show={show} onHide={this.onClose} keyboard size="lg" backdrop="static">
        <Modal.Header>
          <Modal.Title>
            <h3>{title}</h3>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>{html ? <div dangerouslySetInnerHTML={{ __html: message }} /> : message}</Modal.Body>

        <Modal.Footer>
          {hasCancel && (
            <button onClick={this.onCancel} className="btn btn-cancel">
              <i className="fa fa-ban" /> Cancelar
            </button>
          )}

          <button onClick={this.onClose} style={{ marginLeft: 'auto' }} className="btn btn-cancel">
            <i className="fa fa-ban" /> Não
          </button>

          <button onClick={this.onConfirm} className="btn btn-primary">
            <i className="fa fa-check" /> Sim
          </button>
        </Modal.Footer>
      </SmartModal>
    );
  }
}

export default ActionValidatorModal;
